<template>
    <div class="empty_wrapper">
        <div :class="['img_wrapper',{'default_img':imgSize === 'default'},{'small_img':imgSize === 'small'}] ">
            <img v-if="img" :src="img">
        </div>
        <p class="desc" v-if="isShowDesc">{{desc}}</p>
        <slot>
            <a-button v-if="desc ==='采购车为空'" type="link" @click="goShopping">去购物
                <a-icon type="right" />
            </a-button>
        </slot>
    </div>
</template>
<script>
export default {
    name: 'EmptyData',
    props: {
        img: {
            type: String,
            required: false,
            default: require('@/assets/images/basic/empty_order.png')
        },
        desc: {
            type: String,
            required: false,
            default: '暂无数据'
        },
        isShowDesc: {
            type: Boolean,
            required: false,
            default: true
        },
        imgSize: {
            type: String,
            default: 'default'
        }
    },
    methods: {
        goShopping () {
            window.open('https://www.91jf.com/', '_blank')
        }
    }
}
</script>

<style scoped>
.empty_wrapper {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: #ffffff;
    padding-bottom: 20px;
}
.desc {
    font-size: 13px;
    color: #666666;
}

.default_img {
    width: 230px;
    height: 230px;
}

.small_img {
    width: 115px;
    height: 115px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/EmptyData.vue